module.exports = __webpack_public_path__ + "static/media/logo-toppay.99d79f65.png";